import React from 'react';

import Typography from '@material-ui/core/Typography';
import { withStyles } from '@material-ui/core/styles';

import grey from '@material-ui/core/colors/grey';
import red from '@material-ui/core/colors/red';

import SectionMenu from './SectionMenu';

const styles = theme => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    paddingBottom: theme.spacing.unit*3,
  },
  header: {
    height: '25px',
    padding: '10px 10px',
    backgroundColor: grey[100],
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  content: {
    padding: '0px 15px',
  },
  error: {
    color: red[500],
  }
});

const Section = (props) => {
  const {
    classes,
    error,
    title,
    preview,
    children,
    menuItems,
    showContent,
    showAdd,
    tooltipType
  } = props;

  let errorText = error ? ` - ${error}` : "";

  return(
    <div className={classes.root}>
      <div className={classes.header}>
        {!preview &&
          <Typography className={(error && classes.error)}>
            {`SECTION: ${title}${errorText}`}
          </Typography>
        }
        {showAdd && !preview &&
          <SectionMenu menuItems={menuItems} tooltipType={tooltipType}/>
        }
      </div>

      {showContent &&
        <div className={classes.content}>
          {children}
        </div>
      }
    </div>
  );
};

export default withStyles(styles)(Section);



// WEBPACK FOOTER //
// ./src/components/admin/ContentEdit/Section.jsx